import { Popover } from "radix-ui";
import { ReactNode } from "react";

export const PopoverRoot = (props: { children: React.ReactNode }) => {
  const { children } = props;
  return <Popover.Root>{children}</Popover.Root>;
};

export const PopoverTrigger = (props: {
  children: ReactNode;
  className?: string;
  asChild?: boolean;
}) => {
  const { children, className, asChild } = props;
  return (
    <Popover.Trigger
      asChild={asChild}
      className={`c-popover-trigger ${className ?? ""}`}
    >
      {children}
    </Popover.Trigger>
  );
};

export const PopoverContent = (props: {
  children: ReactNode;
  className?: string;
  align?: "start" | "center" | "end";
}) => {
  const { children, className, align = "end" } = props;
  return (
    <Popover.Content
      align={align}
      collisionPadding={16}
      className={`c-popover-content ${className ?? ""}`}
    >
      {children}
      {/* <Popover.Arrow style={{ fill: "white" }} /> */}
    </Popover.Content>
  );
};
